/** @jsxImportSource @emotion/react */
import { menuList } from "constants/menu-list";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import DropdownMenu from "./DropdownMenu";
import { MenuStyle } from "./index.style";

function Menu() {
  const { pathname } = useLocation();
  const [idFocus, setIdFocus] = useState<string>();

  return (
    <div css={MenuStyle.index}>
      <div css={MenuStyle.content}>
        <div css={MenuStyle.listMenu}>
          {menuList.map((item, index) => {
            const isActive = item.isGame
              ? pathname.includes(item.path)
              : pathname === item.path;
            const isFocus = idFocus === item.path;

            return (
              <div
                key={`menu-game-${index}`}
                css={MenuStyle.itemMenu(isActive, isFocus)}
                onMouseEnter={() => setIdFocus(item.path)}
                onMouseLeave={() => setIdFocus("")}
              >
                <Link
                  to={isActive ? "#" : item.path}
                  target={
                    !item.categoryCode.includes("daily") &&
                    !item.categoryCode.includes("live")
                      ? "_self"
                      : "_blank"
                  }
                >
                  <img src={item.icon} alt="error" />
                  <span>{item.title}</span>
                </Link>
                {item.isGame && (
                  <DropdownMenu
                    categoryCode={item.categoryCode}
                    visible={isFocus}
                    menuItem={item}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Menu;
